import ModalFrame from './modals/ModalFrame';
import { ThemeButton } from './ThemeWrapper';

export default function DeleteAccountDialog({ account, busy = false, onCancel, onConfirm }) {
  const name = account?.unixUsername || 'this account';
  return (
    <ModalFrame
      isOpen={Boolean(account)}
      onClose={() => {
        if (!busy) onCancel?.();
      }}
      title={`Delete ${name}?`}
      description="The local Linux account is removed. The home directory stays. A central login with the same name stays. The SMS record stays."
    >
      <p className="text-sm text-gray-700">
        Choose whether this delete saves a home backup on the server. Archives already stored there stay until you remove them from Home backups.
      </p>
      <div className="mt-4 flex flex-wrap justify-end gap-2">
        <ThemeButton type="button" variant="secondary" onClick={onCancel} disabled={busy}>
          Cancel
        </ThemeButton>
        <ThemeButton type="button" variant="secondary" onClick={() => onConfirm(false)} disabled={busy}>
          Delete without backup
        </ThemeButton>
        <ThemeButton type="button" onClick={() => onConfirm(true)} disabled={busy}>
          Delete and keep backup
        </ThemeButton>
      </div>
    </ModalFrame>
  );
}
